import { MoviesRowDataModel } from '@modules/entertainment/models/movies.model';
import { CallStateEnum } from '@shared/models/call-state.model';
import {
  CallStateMethodNames,
  CallStateMethods
} from '@shared/store-features/call-state-feature';

export interface MoviesActionParams {
  data?: MoviesRowDataModel;
  id?: any;
  state?: any;
  handleClose?: () => void;
}

export interface MoviesState extends CallStateMethods {
  callState: CallStateEnum;
  genreCallState: CallStateEnum;
  genreList: any[];
  createRow: (params: MoviesActionParams) => void;
  editRow: (params: MoviesActionParams) => void;
  deleteRow: (params: {
    id: string | string[];
    state: any;
    handleClose?: () => void;
  }) => void;
  createGenre: (params: { data: any; handleClose?: () => void }) => void;
  editGenre: (params: { data: any; id: any; handleClose?: () => void }) => void;
  deleteGenre: (params: any) => void;
  getGenreList: () => void;
  isGenreLoading: () => boolean;
  isGenreLoaded: () => boolean;
  isGenreError: () => boolean;
}

interface MoviesStateMethods extends CallStateMethodNames {
  createRow: 'createRow';
  editRow: 'editRow';
  deleteRow: 'deleteRow';
  createGenre: 'createGenre';
  editGenre: 'editGenre';
  deleteGenre: 'deleteGenre';
  getGenreList: 'getGenreList';
  isGenreLoading: 'isGenreLoading';
  isGenreLoaded: 'isGenreLoaded';
  isGenreError: 'isGenreError';
}

export const MOVIES_INITIAL_STATE: Omit<MoviesStateMethods, keyof MoviesState> =
  {
    genreList: [],
    callState: CallStateEnum.Init,
    genreCallState: CallStateEnum.Init
  };
